module.exports = __webpack_public_path__ + "static/media/payment-bank-info-card.91009d08.svg";